export default "__VITE_ASSET__C3p41D3c__"